/**
 *  @class
 *  @function Pagination
 */

// [FIX] Guard by the actual custom element name ('pagination-theme') so the class is not defined twice.
if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      // [FIX] Start from the page in the URL instead of always assuming page 1.
      // Landing directly on ?page=3 means the next page to load is 4.
      const currentPage = parseInt(new URLSearchParams(document.location.search).get('page'), 10) || 1;
      this.i = currentPage + 1;

      // [FIX] Total page count comes from data-total-pages (set in snippets/pagination.liquid)
      // so the button can be removed once the last page has been loaded.
      this.totalPages = parseInt(this.dataset.totalPages, 10) || null;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;
      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }
      return params;
    }
    loadMore() {
      let base = this;
      if (!this.button) return;
      this.button.addEventListener('click', function (event) {
        // [FIX] The button is now a real <a href="?page=N"> link (crawlable by Google).
        // With JS enabled, stop the normal navigation and append products instead.
        // With JS disabled, the link still works and opens the next page.
        event.preventDefault();
        base.loadProducts();
        this.blur();
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => {
          // [FIX] Treat HTTP errors (404, 500...) as failures instead of rendering an error page.
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((html) => {
          base.renderProducts(html, url);
          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(() => {
          // [FIX] Fallback: if the fetch fails, navigate to the paginated page normally.
          window.location.href = url;
        });
    }
    removeLoadMore() {
      if (this.observer) {
        this.observer.unobserve(this);
      }
      if (this.button) {
        this.button.remove();
      }
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      // [FIX] Stop safely if the fetched page has no product grid.
      if (!grid_to_replace) {
        base.removeAttribute('loading');
        base.removeLoadMore();
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      if (products.length === 0) {
        base.removeAttribute('loading');
        base.removeLoadMore();
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      // [FIX] Update the address bar to the page just loaded (?page=N) without adding a history entry,
      // so reload/share/Back lands on the matching paginated URL.
      history.replaceState(history.state, '', url);

      // [FIX] Remove the button after the last page; otherwise point its href to the next page.
      if (base.totalPages && base.i > base.totalPages) {
        base.removeLoadMore();
      } else if (base.button) {
        base.button.setAttribute('href', document.location.pathname + base.addUrlParam(document.location.search, 'page'));
      }

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}